export const brandFonts = {
  primary: "'Banks Miles Single Line', sans-serif",
};
